// src/components/ProcurementEdit.tsx — v1 (PROC-03, Nov 3, 2026). "Add a line" for a supplier order being edited:
// searches the supplier's catalog (ops_catalog_search, the same search Admin → Orders uses) and adds the chosen item
// through ops_po_add_line (record 160), which also creates the job's bill-of-materials line.
import { useState } from "react";
import { ops, type CatalogHit } from "../lib/ops";

export function CatalogPicker(props: { supplierId: string; disabled: boolean; onAdd: (materialId: string, qty: number, label: string) => Promise<void> }) {
  const [q, setQ] = useState("");
  const [hits, setHits] = useState<CatalogHit[] | null>(null);
  const [pick, setPick] = useState<CatalogHit | null>(null);
  const [qty, setQty] = useState("1");
  const [err, setErr] = useState<string | null>(null);

  async function search() {
    if (q.trim().length < 2) return;
    setErr(null); setPick(null);
    try { setHits(await ops.catalogSearch(props.supplierId, q.trim())); } catch (e) { setErr((e as Error).message); }
  }

  return (
    <div className="inline-form">
      <p className="action-title">Add a line</p>
      <form className="row-actions" onSubmit={(e) => { e.preventDefault(); void search(); }}>
        <input type="search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search this supplier's catalog (name, color, item no.)" aria-label="Search catalog" style={{ flex: 1, minWidth: 0 }} />
        <button type="submit" className="btn" disabled={props.disabled || q.trim().length < 2}>Search</button>
      </form>
      {err && <p className="hint warn">{err}</p>}
      {hits && hits.length === 0 && <p className="hint">Nothing found.</p>}
      {hits && hits.length > 0 && !pick && (
        <ul className="plain-list" style={{ maxHeight: 220, overflowY: "auto", margin: "6px 0", padding: 0, listStyle: "none" }}>
          {hits.slice(0, 25).map((h) => (
            <li key={h.id}>
              <button type="button" className="btn quiet" style={{ width: "100%", textAlign: "left" }} onClick={() => setPick(h)}>
                <span className="mono">{h.sku}</span> · {h.name}{h.color ? ` — ${h.color}` : ""}{h.dimensions ? ` · ${h.dimensions}` : ""}
                {h.price != null ? ` · $${h.price.toFixed(2)}/${h.unit}` : ""}
              </button>
            </li>
          ))}
        </ul>
      )}
      {pick && (
        <div className="row-actions" style={{ alignItems: "center" }}>
          <span style={{ flex: 1, minWidth: 0 }}><span className="mono">{pick.sku}</span> · {pick.name}{pick.color ? ` — ${pick.color}` : ""}</span>
          <input type="number" min={1} step={1} value={qty} onChange={(e) => setQty(e.target.value)} style={{ width: 80 }} aria-label="Quantity" />
          <button type="button" className="btn primary" disabled={props.disabled || !(Number(qty) >= 1)}
            onClick={() => void props.onAdd(pick.id, Math.round(Number(qty)), `${pick.sku} × ${qty}`).then(() => { setPick(null); setHits(null); setQ(""); setQty("1"); })}>Add</button>
          <button type="button" className="btn quiet" onClick={() => setPick(null)}>Back</button>
        </div>
      )}
    </div>
  );
}
